module.exports = "https://coursera_assets.s3.amazonaws.com/images/c955c55292b1822590577a745924f68f.png";